/*
  Author: Vaishnavi
  Date: 18/11/2019
  Issue Description: Visual Bug fixes assigned by Harshvardhan Kore & Tarun Bhandari,
  Spacing fixes done.
*/

/*
Author: Vinod
Date: 04/12//2019
Issue_id JIRA: PL-1980
Issue Description: When added the data and clicked on Skip, should throw an error message that data is not saved.
search_string: UAT_60
*/

/*
Author: Vinod
Date: 06/12//2019
Issue Description: The employer contribution rule dropdown is not getting refreshed, on changing the employee contribution rule to Actual.
search_string: PL_2056
*/

/*
Author: Vinod
Date: 12/12//2019
Issue Description: Reversed value of edliChargesApplicable
search_string: edliChargesApplicable
*/
<template>
  <div>
    <div>
      <!-- <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />-->

      <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
        You have only view permission.
      </div>
      <section class="singleColumnGrid margintop-16">
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="label text-secondary">PF Applicable</div>
          </div>
          <div class="col-12 addflex margintop-16">
            <tl-radio
              label="Yes"
              name="isApplicable"
              id="yes"
              value="yes"
              v-model="isApplicable"
              @change="onIsApplicableChecked(isApplicable)"
              data-vv-as="PF Applicable"
              ref="PFApplicable"
            />
            <tl-radio
              label="No"
              name="isApplicable"
              id="no"
              value="no"
              v-model="isApplicable"
              @change="onIsApplicableChecked(isApplicable)"
              data-vv-as="PF Applicable"
              ref="PFApplicable"
            />
          </div>
        </div>
        <div class="marginleft-15" v-if="pfSettingsData.isApplicable" :disabled="!(ifTeamleaderPermission)">
          <div class="row label text-secondary margintop-16">Remit PF Contribution To</div>
          <div class="addflex margintop-16">
            <tl-radio
              label="RPFC"
              name="pf_contri"
              id="government_body"
              value="GOVERNMENT"
              v-model="pfSettingsData.pfBody"
              @change="onPFContributionSelection(pfSettingsData.pfBody)"
            />
            <tl-radio
              label="Own Trust"
              name="pf_contri"
              id="pf_trust"
              value="PF_TRUST"
              v-model="pfSettingsData.pfBody"
              @change="onPFContributionSelection(pfSettingsData.pfBody)"
            />
          </div>
          <div class="singleColumns margintop-32 margin">
            <tl-select
              label="Employee PF Contribution Rule *"
              name="employeePfContribution"
              labelText="name"
              :options="contribution_rule"
              v-model="employeeContributionRule"
              @change="onPfRuleChange($event, 'employee')"
              data-vv-as="employee PF contribution rule"
              v-validate="'required_if:PFApplicable,yes'"
              :classname="errors.has('employeePfContribution')"
              :errormsg="errors.first('employeePfContribution')"
            ></tl-select>
          </div>
          <div class="row margintop-16" v-if="restrictedWagesEmployee">
            <div class="bg-grey">
              <div class="col-12">
                <b>If Basic + DA &gt; 15000 (Monthly)</b>
              </div>
              <div class="col-12 margin-l-s">
                <p>PF = 12% of 15000</p>
              </div>
              <div class="col-12">
                <b>If Basic + DA &lt;= 15000 (Monthly)</b>
              </div>
              <div class="col-12">
                <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                <p
                  class="margin-t-s"
                >PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
              </div>
            </div>
          </div>
          <div class="row margintop-16" v-if="nonRestrictedWagesEmployee">
            <div class="bg-grey">
              <div class="col-12">
                <b>If Basic + DA &gt; 15000 (Monthly)</b>
              </div>
              <div class="col-12 margin-l-s">
                <p>PF = 12 % of Basic + DA</p>
              </div>
              <div class="col-12">
                <b>If Basic + DA &lt;= 15000 (Monthly)</b>
              </div>
              <div class="col-12">
                <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                <p
                  class="margin-t-s"
                >PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
              </div>
            </div>
          </div>
          <div class="singleColumns margintop-32">
            <tl-select
              label="Employer PF Contribution Rule *"
              name="employerPfContribution"
              labelText="name"
              :options="contribution_rule"
              :class="{'remove-arrow':(restrictedWagesEmployee || nonRestrictedWagesEmployee) }" 
              :disable="(restrictedWagesEmployee || nonRestrictedWagesEmployee)"
              v-model="employerContributionRule"
              @change="onPfRuleChange($event,'employer')"
              data-vv-as="employer PF contribution rule"
              v-validate="'required_if:PFApplicable,yes'"
              :classname="errors.has('employerPfContribution')"
              :errormsg="errors.first('employerPfContribution')"
            ></tl-select>
          </div>

          <div class="row margintop-16" v-if="restrictedWagesEmployer">
            <div class="bg-grey">
              <div class="col-12">
                <b>If Basic + DA &gt; 15000 (Monthly)</b>
              </div>
              <div class="col-12 margin-l-s">
                <p>PF = 12 % of 15000</p>
              </div>
              <div class="col-12">
                <b>If Basic + DA &lt;= 15000 (Monthly)</b>
              </div>
              <div class="col-12">
                <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                <p
                  class="margin-t-s"
                >PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
              </div>
            </div>
          </div>

          <div class="row margintop-16" v-if="nonRestrictedWagesEmployer">
            <div class="bg-grey">
              <div class="col-12">
                <b>If Basic + DA &gt; 15000 (Monthly)</b>
              </div>
              <div class="col-12 margin-l-s">
                <p>PF = 12 % of Basic + DA</p>
              </div>
              <div class="col-12">
                <b>If Basic + DA &lt;= 15000 (Monthly)</b>
              </div>
              <div class="col-12">
                <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                <p
                  class="margin-t-s"
                >PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
              </div>
            </div>
          </div>

          <div class="label margintop-32">EDLI Contribution</div>
          <div class="row margintop-16">
            <!-- Start edliChargesApplicable -->
            <tl-radio
              label="Exempted"
              name="edli_charges"
              id="exempted"
              value="false"
              v-model="pfSettingsData.edliChargesApplicable"
            />
            <tl-radio
              label="Not Exempted"
              name="edli_charges"
              id="not_exempted"
              value="true"
              v-model="pfSettingsData.edliChargesApplicable"
            />
          </div>
          <div class="margintop-16">
            <div class="bg-grey" v-if="pfSettingsData.edliChargesApplicable">
              <div class="col-12" v-if="pfSettingsData.edliChargesApplicable == 'false'">
                <p>EDLI Inspection Charges = 0.005 % of EPS wages</p>
                <p>EPS Wages = PF wages or 15000 (whichever is lower)</p>
              </div>
              <div class="col-12" v-if="pfSettingsData.edliChargesApplicable == 'true'">
                <p>EDLI Charges = 0.5 % of EPS wages</p>
                <p>EPS wages = PF wages or 15000 (whichever is lower)</p>
              </div>
            </div>
          </div>
          <!-- End edliChargesApplicable -->
          <div class="margintop-16">
            <tl-checkbox
              label="Include as a part of CTC"
              :checked="pfSettingsData.edliInspectionChargesPartOfCtc"
              @change="(val)=> pfSettingsData.edliInspectionChargesPartOfCtc = val"
            ></tl-checkbox>
          </div>
          <div class="row margintop-32">
            <div class="margin-b-s">
              <div v-if="pfSettingsData.pfBody != 'PF_TRUST'" class="label">PF Admin Charges</div>
              <div v-if="pfSettingsData.pfBody == 'PF_TRUST'" class="label">PF Inspection Charges</div>
            </div>
            <div class="bg-grey margintop-16">
              <div class="col-12" v-if="pfSettingsData.pfBody != 'PF_TRUST'">
                <p class="margin-b-xs">Admin Charges = 0.5 % of PF Wages</p>
                <p>Total Admin Charges = 0.5 % of PF Wages or Rs 500 per LE whichever is higher</p>
              </div>
              <div class="col-12" v-if="pfSettingsData.pfBody == 'PF_TRUST'">
                <p>Inspection charges = 0.18 % of PF wages</p>
                <p>PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus</p>
              </div>
            </div>
            <div class="margintop-16">
              <tl-checkbox
                label="Include as a part of CTC"
                :checked="pfSettingsData.adminChargesPartOfCtc"
                @change="(val)=>pfSettingsData.adminChargesPartOfCtc = val"
              ></tl-checkbox>
            </div>
          </div>
          <div class="row margintop-32">
            <txt
              type="text"
              label="Authorised Signatory"
              name="authorised_signatory"
              v-model="pfSettingsData.authorisedSignatory"
            />
            <txt
              type="text"
              label="Designation"
              name="designation"
              v-model="pfSettingsData.designation"
            />
          </div>
            <div class="margintop-40">
              <tl-checkbox
                label="Impact PF Proration for restricted cases based on working days"
                :checked="pfSettingsData.pfRestrictionProrated"
                @change="(val)=>pfSettingsData.pfRestrictionProrated = val"
              ></tl-checkbox>
            </div>
         
        </div>
      </section>
      <tick-animation v-if="showSuccessMsg"></tick-animation>

      <!-- Start UAT_60 -->
      <pop-up-message
        v-if="showWarningPopup"
        message="On skip, your made changes won't be saved!"
        popupType="Warning"
        :popupHeaderMessage="'Warning'"
        :closable="false"
      >
        <template v-slot:bottomContent>
          <div class="popup-btn-group">
            <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
            <button class="btn-popup" type="button" @click="skip()">Skip</button>
          </div>
        </template>
      </pop-up-message>
      <!-- End UAT_60 -->
      <bottom-action-container>
        <btn-skip @navClicked="skip()"></btn-skip>
        <template slot="end">
          <btn-grp>
            <btn text="Previous" type="secondary" @click="previous" />
            <btn text="Next" type="primary" @click="savePFSettings()" v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>
<script>
import { selectMixin } from "@/mixins/selectMixin";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  mixins: [selectMixin],
  props: {},
  components: {},
  data() {
    return {
      restrictedWagesEmployee: false,
      nonRestrictedWagesEmployee: false,
      restrictedWagesEmployer: false,
      nonRestrictedWagesEmployer: false,
      isContriToPfTrust: false,
      showSuccessMsg: false,
      showWarningPopup: false, // UAT_60
      responseMsg: "",
      errmsg: "",
      toast: false,
      isApplicable: "no",
      employeeContributionRule: null,
      employerContributionRule: null,
      pfSettingsData: {
        isApplicable: false,
        employeeContributionRule: "",
        employerContributionRule: "",
        pfBody: "GOVERNMENT",
        edliChargesApplicable: "false",
        //espCalculationRule: null,
        edliInspectionChargesPartOfCtc: false,
        adminChargesPartOfCtc: false,
        authorisedSignatory: "",
        designation: "",
        pfRestrictionProrated:false
      },
      contribution_rule: [
        { id: "RESTRICT", name: "Calculate on Restricted PF Wages" },
        { id: "NON_RESTRICT", name: "Calculate on Actual PF Wages" }
      ],
      statutorySettingsValue: false,
      role: ""
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getPfSettingsData: "onboard/statutoryinfo/pfsettings/getPfData"
    }),
    ...mapState("onboard/statutoryinfo/pfsettings", {
      pfData: state => state.data
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      } else {
        return this.getleid(0);
      }
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.statutorySettingsValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.statutorySettingsValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  activated() {
    this.resetForm();
    this.setPfData(this.pfData[this.le_id]);
    this.getOrgLeIdList();
  },
  mounted() {
    this.resetForm();
    if (!this.pfData[this.le_id]) {
      this.getPFInfo();
    } else {
      this.setPfData(this.pfData[this.le_id]);
    }
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions("onboard/statutoryinfo/pfsettings/", {
      act_create: "create",
      act_fetchAll: "fetchAll"
    }),
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    // pf data setting for first time if data is not available in store - 25/11/2019
    async getPFInfo() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        if (res.data.status) {
          this.setPfData(res.data.payload.data);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.message;
      }
    },

    /* function to set PF form data */
    setPfData(Obj) {
      try {
        if (Obj && Object.keys(Obj).length) {
          this.isApplicable =
            Obj.isApplicable.toString() == "true" ? "yes" : "no";
          this.pfSettingsData.isApplicable = Obj.isApplicable;
          this.employeeContributionRule = this.contribution_rule.find(
            item => item.id == Obj.employeeContributionRule
          );
          if (Obj.employeeContributionRule == "RESTRICT") {
            this.restrictedWagesEmployee = true;
            this.nonRestrictedWagesEmployee = false;
          } else if (Obj.employeeContributionRule == "NON_RESTRICT") {
            this.nonRestrictedWagesEmployee = true;
            this.restrictedWagesEmployee = false;
          } else {
            this.restrictedWagesEmployee = false;
            this.nonRestrictedWagesEmployee = false;
          }
          this.employerContributionRule = this.contribution_rule.find(
            item => item.id == Obj.employerContributionRule
          );
          if (Obj.employerContributionRule == "RESTRICT") {
            this.restrictedWagesEmployer = true;
          } else if (Obj.employerContributionRule == "NON_RESTRICT") {
            this.nonRestrictedWagesEmployer = true;
          } else {
            this.restrictedWagesEmployer = false;
            this.nonRestrictedWagesEmployer = false;
          }
          this.pfSettingsData.pfBody = Obj.pfBody ? Obj.pfBody : "GOVERNMENT";
          this.pfSettingsData.edliChargesApplicable = Obj.edliChargesApplicable.toString();
          this.pfSettingsData.adminChargesPartOfCtc = Obj.adminChargesPartOfCtc;
          this.pfSettingsData.edliInspectionChargesPartOfCtc =
            Obj.edliInspectionChargesPartOfCtc;
          this.pfSettingsData.authorisedSignatory = Obj.authorisedSignatory;
          this.pfSettingsData.designation = Obj.designation;
          this.pfSettingsData.pfRestrictionProrated = Obj.pfRestrictionProrated;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to submit form data */
    async submitPFSettingsData() {
      try {
        if (this.isApplicable == "yes") {
          this.pfSettingsData.employeeContributionRule = this.employeeContributionRule.id;
          this.pfSettingsData.employerContributionRule = this.employerContributionRule.id;
          if (this.isApplicable == "yes") {
            this.pfSettingsData.isApplicable = true;
          } else {
            this.pfSettingsData.isApplicable = false;
          }
          if (this.pfSettingsData.edliChargesApplicable == "true") {
            this.pfSettingsData.edliChargesApplicable = true;
          } else {
            this.pfSettingsData.edliChargesApplicable = false;
          }
        } else {
          this.pfSettingsData.employeeContributionRule = null;
          this.pfSettingsData.employerContributionRule = null;
          this.pfSettingsData.edliChargesApplicable = false;
          this.pfSettingsData.pfBody = null;
          this.pfSettingsData.edliInspectionChargesPartOfCtc = false;
          this.pfSettingsData.authorisedSignatory = null;
          this.pfSettingsData.designation = null;
          this.pfSettingsData.pfRestrictionProrated=false;
        }
        this.$root._data.isSaving = true;
        let res = await this.act_create({
          data: {
            ...this.pfSettingsData,
            le_id: this.le_id,
            type: "POST"
          }
        });
        setTimeout(() => {
          if (res.data.status) {
            this.responseMsg = "PF Settings " + res.data.message;
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to hide success popup and navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("next");
      }, 1000);
    },
    /** On PF Applicable radio buttons click */
    onIsApplicableChecked(val) {
      try {
        if (val == "yes") {
          this.pfSettingsData.isApplicable = true;
        } else {
          this.pfSettingsData.isApplicable = false;
          this.showPfForm = false;
          this.resetForm();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to reset the form */
    resetForm() {
      try {
        this.employeeContributionRule = null;
        this.employerContributionRule = null;
        this.restrictedWagesEmployee = false;
        this.nonRestrictedWagesEmployee = false;
        this.restrictedWagesEmployer = false;
        this.nonRestrictedWagesEmployer = false;
        this.isApplicable = "no";
        this.pfSettingsData = {
          isApplicable: false,
          employeeContributionRule: "",
          employerContributionRule: "",
          pfBody: "GOVERNMENT",
          edliChargesApplicable: "false",
          //espCalculationRule: null,
          edliInspectionChargesPartOfCtc: false,
          adminChargesPartOfCtc: false,
          authorisedSignatory: "",
          designation: "",
          pfRestrictionProrated:false
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On Remit PF Contribution To radio buttons click */
    onPFContributionSelection(val) {
      try {
        if (val == "PF_TRUST") {
          this.isContriToPfTrust = true;
        } else {
          this.isContriToPfTrust = false;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On PF Ruke dropdown change */
    onPfRuleChange(event, type) {
      try {
        if (type == "employee") {
          this.employeeContributionRule = event;
          if (event.id == "RESTRICT") {
            this.restrictedWagesEmployee = true;
            this.nonRestrictedWagesEmployee = false;
            this.restrictedWagesEmployer = true;
            this.nonRestrictedWagesEmployer = false;
            this.employerContributionRule = event;
          } else {
            this.restrictedWagesEmployee = false;
            this.nonRestrictedWagesEmployee = true;
            this.restrictedWagesEmployer = false;
            this.nonRestrictedWagesEmployer = true;
            this.employerContributionRule = event; // PL_2056
          }
        } else {
          this.employerContributionRule = event;
          if (event.id == "RESTRICT") {
            this.restrictedWagesEmployer = true;
            this.nonRestrictedWagesEmployer = false;
          } else {
            this.restrictedWagesEmployer = false;
            this.nonRestrictedWagesEmployer = true;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to validate form data */
    savePFSettings() {
      if(this.ifAnchor) {
          this.nextPage();
        } else {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitPFSettingsData();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
      }
    },
    /** Navigate to previous screen */
    previous() {
      this.$emit("previous");
    },
    // Start UAT_60
    cancelEvent() {
      this.showWarningPopup = false;
    },
    /** On skip button click */
    skip() {
      this.showWarningPopup = false;
      this.$emit("skip");
    },
    // End UAT_60

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$emit("skip");
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.statutorySettingsValue = data.data.user.permissions.statutory_settings ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";

.bg-grey {
  background-color: #f1f1f1;
  padding: 10px 15px;
  width: 100%;
  p {
    margin-bottom: 5px;
    font-size: 12px;
  }
}

/*For filters on dashboard*/
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(6, minmax(180px, 1fr));
}

.singleColumns {
  width: 33%;
}
.addflex {
  display: flex;
}
.label {
  font-size: 14px;
  font-weight: 600;
  color: #444444;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
